import { Component, forwardRef, Renderer2, ViewChild, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { StationService } from '../../../service/station/station.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteStationComponent),
  multi: true,
};

@Component({
  selector: 'app-autocomplete-station',
  templateUrl: './autocomplete-station.component.html',
  styleUrls: ['./autocomplete-station.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class AutocompleteStationComponent implements ControlValueAccessor, OnInit {
    @Input() stationId: number;
    @Output() onMyChange = new EventEmitter();
    @Input() disabled: boolean;

    @ViewChild('input') textarea;

    public stationsOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    public sel: any;

    public modViewInformationStationDialog: boolean;

    constructor(
        private renderer: Renderer2,
        public stationService: StationService
    ) {
        this.page = 1;
        this.per_page = 10;
        this.modViewInformationStationDialog = false;
    }

    public ngOnInit() {
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
        if (this.stationId) {
            this.filters.push({key: 'id-lk', value: String(this.stationId)});
        }
        this.getStations(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onMyChange.emit(this.sel);
        this.onChange(this.sel);
        this.onTouched(this.sel);
    }

    public loadStationsLazy(event) {
        this.getStations(event.query);
    }

    getStations(query?: string, filters?: any[]) {
        this.stationService.getStation(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
            response => {
                this.stationsOptions = response.json().data;
                if (this.stationId) {
                    this.stationId = undefined;
                    this.sel = this.stationsOptions[0];
                    this.filters = [];
                    this.filters.push({key: 'activated-lk', value: '1'});
                    if (this.stationId) {
                        this.filters.push({key: 'id-lk', value: String(this.stationId)});
                    }
                }

                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                // this.stationsOptions = [];
                // stations.forEach(element => {
                //     if (this.stationId === element.id) {
                //         this.stationsOptions.push({id: element.id, name: element.name, selected: true, company: element.company});
                //     } else {
                //         this.stationsOptions.push({id: element.id, name: element.name, selected: false, company: element.company});
                //     }
                // });
            },
            error => {
                this.stationsOptions = [];
                this.stationsOptions.push({id: '', name: 'Error'});
            }
        );
    }

    public showInformationStationDialog() {
        this.modViewInformationStationDialog = true;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/stations/autocomplete-station/autocomplete-station.component.ts